"use client";

import { useEffect } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import HowItWorks from "@/components/HowItWorks";
import Showcase from "@/components/Showcase";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";

export default function HomePage() {
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const anchor = (e.target as HTMLElement).closest('a[href*="#"]');
      const href = anchor?.getAttribute("href");
      if (!href || !href.includes("#")) return;
      const [pathPart, hash] = href.split("#");
      const targetId = hash?.trim();
      if (!targetId) return;
      const pathname = window.location.pathname;
      const linkPath = (pathPart || "/").replace(/\/$/, "") || "/";
      const currentPath = pathname.replace(/\/$/, "") || "/";
      if (linkPath !== currentPath) return;
      e.preventDefault();
      const el = document.getElementById(targetId);
      if (el) {
        window.scrollTo({
          top: el.getBoundingClientRect().top + window.scrollY - 80,
          behavior: "smooth",
        });
      }
    };
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  return (
    <main className="relative">
      <Header />
      <Hero />
      <HowItWorks />
      <Showcase />
      <ContactForm />
      <Footer />
    </main>
  );
}
